import * as Sentry from "@sentry/react";
import { useAutoGenerateDialogSpeech } from "@/api/fapinstructor/admin/speech/auto-generate-dialog-speech";
import { useSpeechQueueClear } from "@/api/fapinstructor/admin/speech/clear-speech-queue";
import { Box, Button, Group, Title } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "@/components/page";

export const Route = createFileRoute("/_authenticated/_subscribed/admin")({
  component: RouteComponent,
});

function RouteComponent() {
  const autoGenerateDialogSpeechMutation = useAutoGenerateDialogSpeech();
  const speechQueueClearMutation = useSpeechQueueClear();

  return (
    <Page title="Admin Console">
      <Box m="xl">
        <Title>Admin Console</Title>
        <Box mt="xl">
          <Title order={2}>Tools</Title>
          <Group>
            <Button
              onClick={() => {
                speechQueueClearMutation.mutate(undefined, {
                  onSuccess() {
                    notifications.show({
                      title: "Queue Cleared",
                      message: "Successfully cleared speech queue",
                      color: "green",
                      autoClose: 3000,
                    });
                  },
                  onError(error) {
                    Sentry.captureException(error);
                    notifications.show({
                      title: "Failed to clear the queue",
                      message:
                        "A problem occurred while trying to clear the speech queue",
                      color: "red",
                      autoClose: 3000,
                    });
                  },
                });
              }}
            >
              Clear Speech Queue
            </Button>
            <Button
              onClick={() => {
                autoGenerateDialogSpeechMutation.mutate(undefined, {
                  onSuccess() {
                    notifications.show({
                      title: "Auto-generated Dialog Speech",
                      message: "Successfully auto-generated dialog speech",
                      color: "green",
                      autoClose: 3000,
                    });
                  },
                  onError(error) {
                    Sentry.captureException(error);
                    notifications.show({
                      title: "Failed to auto-generated Dialog Speech",
                      message:
                        "A problem occurred while trying to auto-generated dialog speech",
                      color: "red",
                      autoClose: 3000,
                    });
                  },
                });
              }}
            >
              Auto-generate Dialog Speech
            </Button>
          </Group>
        </Box>
      </Box>
    </Page>
  );
}
